import GmailHistoryApi from '@/api/GmailHistory/api'
import {get} from 'lodash'

export default {
  computed: {
    windowAuthPopup: {
      get () {
        return this.$store.getters.windowAuthPopup
      },
      set (data) {
        this.$store.dispatch('setWindowAuthPopup', data)
      }
    },
    userEmail () {
      return get(this.$store.getters.userInfo, 'email', '')
    }
  },
  methods: {
    setWatchGmailHistory () {
      GmailHistoryApi.setWatch({userEmail: this.userEmail})
        .then(({data}) => {
          if (data.status === 'not auth') this.$router.push({name: 'SingIn'})
        })
        .catch(e => {
          console.error(e)
        })
    },
    async getAuthGmailHistory () {
      try {
        const resp = await GmailHistoryApi.getAuth({userEmail: this.userEmail})
        const url = get(resp, 'data.url', '')
        if (!url) {
          return true
        } else {
          this.windowAuthPopup = { url }
          return false
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkAuthGmail ({openPopup}) {
      const auth = await this.getAuthGmailHistory()
      if (openPopup && !auth) this.openPopupAuth()
      if (!auth && this.$route.name !== 'SingIn') this.$router.push({name: 'SingIn'})
      if (auth && this.$route.name === 'SingIn') this.$router.push({name: 'Dashboard'})
    },
    openPopupAuth () {
      const params = 'status=no,location=no,toolbar=no,menubar=no,width=500,height=552'
      this.windowAuthPopup.popup = window.open(this.windowAuthPopup.url, 'login', params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setWatchGoogle.js